export const white = '#fff';
export const black = '#333';
export const charcoal = '#404040';
export const offWhite = '#f5f5f5';
export const smoke = '#eee';
export const darkSmoke = '#222';
export const brandPrimary = '#57ac2d';
export const orange = '#FF5900';